const Loader = () => {
  return <div />;
};

export default Loader;
